import { type AnyNode, hasChildren, isComment, isText } from 'domhandler';

/**
 * Get a node's text content. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the text content of.
 * @returns `node`'s text content.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
 */
export function textContent(node: AnyNode | AnyNode[]): string {
  if (Array.isArray(node)) return node.map(textContent).join('');
  if (hasChildren(node) && !isComment(node)) {
    return textContent(Array.from(node.childNodes.values()));
  }
  if (isText(node)) return node.data;
  return '';
}
